import { createContext, useContext, useEffect, useRef } from "react"
import { useSearchParams } from "react-router-dom"

const LandingCountryDetectContext = createContext(null)

export function LandingCountryDetectProvider({ value, children }) {
  return (
    <LandingCountryDetectContext.Provider value={value}>
      {children}
    </LandingCountryDetectContext.Provider>
  )
}

export function useLandingCountryDetection() {
  const value = useContext(LandingCountryDetectContext)
  if (!value) {
    throw new Error("LandingCountryDetectProvider is missing")
  }
  return value
}

export function countryParamPresent(search) {
  if (typeof search === "string") {
    return new URLSearchParams(search).has("country")
  }
  const has = search?.has
  if (typeof has !== "function") return false
  return has.call(search, "country") === true
}

function countryFromBody(body) {
  if (body === null || typeof body !== "object" || Array.isArray(body)) return null
  if (body.country == null) return null
  if (typeof body.country === "string" && /^[A-Z]{2}$/.test(body.country)) {
    return body.country
  }
  return null
}

function createSession() {
  let resolve
  const promise = new Promise((done) => {
    resolve = done
  })
  return { promise, resolve, done: false }
}

export function useLandingCountryDetect() {
  const [searchParams] = useSearchParams()
  const countryInQuery = countryParamPresent(searchParams)
  const sessionRef = useRef(null)
  const countryInQueryRef = useRef(countryInQuery)
  countryInQueryRef.current = countryInQuery

  if (countryInQuery) {
    sessionRef.current = null
  } else if (!sessionRef.current) {
    sessionRef.current = createSession()
  }

  function whenSettled() {
    if (countryInQueryRef.current) return Promise.resolve(null)
    return sessionRef.current.promise
  }

  useEffect(() => {
    if (countryInQuery) return undefined
    const session = sessionRef.current
    const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")

    function finish(value) {
      if (!session || session.done) return
      session.done = true
      session.resolve(value)
    }

    if (!backendUrl) {
      console.log(null)
      finish(null)
      return undefined
    }
    const controller = new AbortController()

    async function loadCountry() {
      try {
        const response = await fetch(
          `${backendUrl}/api/marketing/roofing-light-country`,
          { method: "GET", signal: controller.signal }
        )
        if (controller.signal.aborted) return
        if (!response.ok) {
          console.log(null)
          finish(null)
          return
        }
        let body
        try {
          body = await response.json()
        } catch (error) {
          if (controller.signal.aborted) return
          console.log(null)
          finish(null)
          return
        }
        if (controller.signal.aborted) return
        const code = countryFromBody(body)
        console.log(code)
        finish(code)
      } catch (error) {
        if (controller.signal.aborted || error?.name === "AbortError") return
        console.log(null)
        finish(null)
      }
    }

    loadCountry()
    return () => controller.abort()
  }, [countryInQuery])

  return { whenSettled }
}
